/**
 * Vytvoří seznam aktivních případů z hlavního případu a jeho dílčích zadostí
 */
export const buildActiveInfoList = (data) => {
    var _a, _b, _c, _d, _e;
    if (!data)
        return [];
    const aktivniPripadId = (_a = data.pripad) === null || _a === void 0 ? void 0 : _a.id;
    if (!aktivniPripadId)
        return [];
    return [
        {
            id: aktivniPripadId,
            pripad: data.pripad,
            typ: (_b = data.pripad) === null || _b === void 0 ? void 0 : _b.typ,
            stav: (_c = data.pripad) === null || _c === void 0 ? void 0 : _c.stav,
            zadostId: (_d = data.pripad) === null || _d === void 0 ? void 0 : _d.id,
        },
        ...((_e = data.dilciZadosti) !== null && _e !== void 0 ? _e : []).map((zadost) => ({
            id: {
                idSystemPrijemceZadosti: zadost === null || zadost === void 0 ? void 0 : zadost.idSystemPrijemceZadosti,
                typ: zadost === null || zadost === void 0 ? void 0 : zadost.typ,
            },
            typ: zadost.typ,
            pripad: zadost.pripad,
            stav: zadost.stav,
        })),
    ];
};
/**
 * Najde aktivní informace podle ID
 */
export const findActiveInfo = (activeInfoList, activePripadId) => {
    if (activePripadId === null || activePripadId === -1) {
        return undefined;
    }
    return activeInfoList.find(zadost => {
        var _a, _b;
        return typeof activePripadId === 'object' && typeof (zadost === null || zadost === void 0 ? void 0 : zadost.id) === 'object'
            ? ((_a = zadost === null || zadost === void 0 ? void 0 : zadost.id) === null || _a === void 0 ? void 0 : _a.idSystemPrijemceZadosti) === (activePripadId === null || activePripadId === void 0 ? void 0 : activePripadId.idSystemPrijemceZadosti) && ((_b = zadost === null || zadost === void 0 ? void 0 : zadost.id) === null || _b === void 0 ? void 0 : _b.typ) === (activePripadId === null || activePripadId === void 0 ? void 0 : activePripadId.typ)
            : (zadost === null || zadost === void 0 ? void 0 : zadost.id) === activePripadId;
    });
};
/**
 * Zjistí, zda je aktivní daný případný prvek
 */
export const isActiveItem = (itemId, activePripadId) => {
    if (activePripadId === null)
        return false;
    if (typeof activePripadId === 'object' && typeof itemId === 'object') {
        return itemId.idSystemPrijemceZadosti === activePripadId.idSystemPrijemceZadosti && itemId.typ === activePripadId.typ;
    }
    return itemId === activePripadId;
};
//# sourceMappingURL=activeInfoHelpers.js.map